import React from 'react';
import MultiParamsBarChart from './MultiParamsBarChart';
import CardSkeleton from 'components/common/skeleton/CardSkeleton';
import { Col, Row } from 'react-bootstrap';
import MultiParamSeasonalChart from './MultiParamSeasonalChart';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

function ComparisonChart({ observation, loading }) {
  if (loading) {
    return <CardSkeleton footer={false} />;
  }
  return (
    <>
      {!isEmpty(observation) &&
        Object.entries(observation).map(([key, value], index) => (
          <Col key={index} md={value.width || 6}>
            {observation[key].type_format === 'line' ? (
              <MultiParamsBarChart type="line" chartData={value} />
            ) : observation[key].type_format === 'bar' ||
              observation[key].type_format === 'pie' ? (
              <MultiParamsBarChart type="bar" chartData={value} />
            ) : observation[key].type_format === 'seasonal_bar' ? (
              <MultiParamSeasonalChart type="line" chartData={value} />
            ) : (
              <></>
            )}
          </Col>
        ))}
    </>
  );
}

ComparisonChart.propTypes = {
  observation: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired
};

export default ComparisonChart;
